import { Typography, useTheme } from '@mui/material';
import Box from '@mui/material/Box';
import { OverridableComponent } from '@mui/material/OverridableComponent';
import Paper from '@mui/material/Paper';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';

interface InventoryCardsProps {
  Icon: OverridableComponent<SvgIconTypeMap<object, 'svg'>>;
  title: string;
  amount: number | string;
}

const InventoryCards = ({ Icon, title, amount }: InventoryCardsProps) => {
  const theme = useTheme();
  return (
    <Box sx={{ position: 'relative' }}>
      <Box
        sx={{
          backgroundColor: 'white',
          position: 'absolute',
          top: '-30%',
          left: { xxs: '35%', xs: '30%', md: '35%', lg: '30%', xl: '25%' },
          padding: '1rem 1rem 0 ',
          borderRadius: '50% 50% 0 0',
          boxShadow: '1px -10px 11px -16px rgba(0,0,0,0.75)',
        }}
      >
        <Icon fontSize="large" />
      </Box>
      <Paper
        elevation={3}
        sx={{
          minHeight: '90px',
          display: 'flex',
          p: '2rem 0 1rem 0',
          flexDirection: 'column',
          gap: '0.5rem',
          alignItems: 'center',
          textAlign: 'center',
          width: '100%',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant="body2"
          fontWeight={theme.typography.fontWeightMedium}
          sx={{ color: theme.palette.grey[800] }}
        >
          {title}
        </Typography>
        <Typography variant="body2" fontWeight={theme.typography.fontWeightBold} color="secondary">
          {amount}
        </Typography>
      </Paper>
    </Box>
  );
};

export default InventoryCards;
